import React, { useCallback, useContext, useMemo } from 'react'
import { HeaderStyles } from './Style'
import { AutoComplete, Button } from 'components/Form';
import { Divider } from '@mui/material';
import { SearchOutlined } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { getSemesterAndYearLabel } from 'components/SelectSemesterAndYear/SelectSemesterAndYear';
import { SystemReviewContext } from '../SystemReviewContext';
import SelectSemesterAndYear from 'components/SelectSemesterAndYear';
import CustomAutoComplete from './CustomAutoComplete';
import { getAffiliationLabel } from 'pages/School/Affiliations/hooks/getAffiliationLabel';
import { secretStorage } from 'config';

const educationLevelOptions = [
    { id: null, name: 'הכל' },
    { id: 'elementary', name: 'יסודי' },
    { id: 'middle', name: 'חטיבה' },
]

const AffiliationsHeader = (props) => {
    const { Context, description, semesterControl } = props
    const { setDraftAssessmentFilters, setAppliedAssessmentFilters, isSchoolGroup, draftAssessmentFilters } = useContext(SystemReviewContext)
    const { semesterAndYear, setSemesterAndYear, cities, grades, affiliationGroups, affiliations, totalTestTakers } = useContext(Context)
    const { brokenDisplay } = useSelector(state => state.general)
    const { roleIndex } = useSelector(state => state.user)

    const storage = secretStorage.getItem("user")
    const { user_data } = storage || {}
    const { learning_groups: allLearningGroups } = user_data?.[roleIndex]?.user_data || {}

    const selectedAffiliationIds = useMemo(() =>
        draftAssessmentFilters.affiliations?.map(a => a.id) || []
    , [draftAssessmentFilters.affiliations])

    const learningGroupOptions = useMemo(() => {
        if (!allLearningGroups) return []
        if (!selectedAffiliationIds.length) return allLearningGroups
        return allLearningGroups.filter(lg => selectedAffiliationIds.includes(lg.affiliation))
    }, [allLearningGroups, selectedAffiliationIds])

    const handleChangeAssessmentsFilters = useCallback((key, value) => {
        const nAssessmentFilters = { ...draftAssessmentFilters, [key]: value }
        if (key === "affiliations" || key === "group") {
            nAssessmentFilters.learning_group = null
        }
        setDraftAssessmentFilters(nAssessmentFilters)
    }, [draftAssessmentFilters])

    const refetchData = useCallback(() => {
        setAppliedAssessmentFilters(draftAssessmentFilters)
    }, [draftAssessmentFilters])

    return (
        <HeaderStyles>
            <div className='filters-row'>
                <div className='label'>{"תציג נתונים של "}</div>
                <AutoComplete
                    width={150}
                    renderCustomInput={(params) => (
                        <CustomAutoComplete {...params} />
                    )}
                    options={affiliationGroups}
                    input={{
                        value: draftAssessmentFilters.group,
                        onChange: (val) => handleChangeAssessmentsFilters("group", val)
                    }}
                />
                <span className='label'>{" בשלב חינוך "}</span>
                <AutoComplete
                    width={120}
                    renderCustomInput={(params) => (
                        <CustomAutoComplete {...params} />
                    )}
                    options={educationLevelOptions}
                    input={{
                        value: draftAssessmentFilters.grade_group ?? educationLevelOptions[0],
                        onChange: (val) => handleChangeAssessmentsFilters("grade_group", val?.id ? val : null)
                    }}
                />
                <span className='label'>{" בעיר "}</span>
                <AutoComplete
                    width={150}
                    renderCustomInput={(params) => (
                        <CustomAutoComplete
                            {...params}
                            showBlurred={brokenDisplay}
                            hasValue={draftAssessmentFilters.cities?.length}
                        />
                    )}
                    name="cities"
                    showBlurred={brokenDisplay}
                    placeholder="בחר"
                    options={cities}
                    labelKey="label"
                    multiple
                    input={{
                        value: draftAssessmentFilters.cities,
                        onChange: (val) => handleChangeAssessmentsFilters("cities", val)
                    }}
                />
                <span className='label'>{"בבית ספר"}</span>
                {/* {draftAssessmentFilters.group?.name != groupNames.schools && */}
                <AutoComplete
                    options={affiliations?.filter(aff => aff.group == draftAssessmentFilters?.group?.id)}
                    name="affiliations"
                    width={150}
                    renderCustomInput={(params) => (
                        <CustomAutoComplete
                            {...params}
                            showBlurred={brokenDisplay}
                            hasValue={draftAssessmentFilters.affiliations?.length} />
                    )}
                    // options={affiliations}
                    showBlurred={brokenDisplay}
                    placeholder="בחר"
                    multiple
                    getTooltip={brokenDisplay ? null : (opt) => getAffiliationLabel(opt)}
                    input={{
                        value: draftAssessmentFilters.affiliations,
                        onChange: (val) => handleChangeAssessmentsFilters("affiliations", val)
                    }}
                />
                {(isSchoolGroup || !draftAssessmentFilters.group) &&
                    <>
                        <span className='label'>{"בשכבה"}</span>
                        <AutoComplete
                            width={150}
                            // options={affiliations?.filter(aff => aff.group == draftAssessmentFilters?.group?.id)}
                            options={grades}
                            renderCustomInput={(params) => (
                                <CustomAutoComplete
                                    {...params}
                                    hasValue={draftAssessmentFilters.grades?.length}
                                />
                            )}
                            placeholder="בחר"
                            multiple
                            input={{
                                value: draftAssessmentFilters.grades,
                                onChange: (val) => handleChangeAssessmentsFilters("grades", val)
                            }}
                        />
                    </>
                }
                {!isSchoolGroup && draftAssessmentFilters.group &&
                    <>
                        <span className='label'>{"בקבוצה"}</span>
                        <AutoComplete
                            width={150}
                            options={learningGroupOptions}
                            renderCustomInput={(params) => (
                                <CustomAutoComplete
                                    {...params}
                                    hasValue={!!draftAssessmentFilters.learning_group}
                                />
                            )}
                            placeholder="בחר"
                            input={{
                                value: draftAssessmentFilters.learning_group,
                                onChange: (val) => handleChangeAssessmentsFilters("learning_group", val)
                            }}
                        />
                    </>
                }
                <Button action={refetchData} color="primary500" size="small">
                    <SearchOutlined fontSize='small' />
                    {"מיון תוצאות"}
                </Button>
                <Divider className='vertical-line' />
                {semesterControl ?? (
                    <AutoComplete
                        renderCustomInput={(params) => (
                            <CustomAutoComplete {...params} readOnlyInput width={180} placeholder="שנה וסמסטר" />
                        )}
                        minWidth={180}
                        width={180}
                        className="semester-and-year"
                        getOptionLabel={getSemesterAndYearLabel}
                        name="semester_and_year"
                        paperComponent={SelectSemesterAndYear}
                        input={{
                            value: semesterAndYear,
                            onChange: setSemesterAndYear
                        }}
                    />
                )}
            </div>
            <div>
                {description}
                {totalTestTakers}
                {" תלמידי "}
                <b>
                    {
                        draftAssessmentFilters.cities?.length == cities?.length || !draftAssessmentFilters.cities?.length ?
                            " כל הערים " :
                            <>
                                {" העיר "}
                                <span className={`${brokenDisplay && 'blurred2'}`}>
                                    {draftAssessmentFilters.cities[0].label}
                                    {draftAssessmentFilters.cities?.length > 1 && ` (+${draftAssessmentFilters.cities?.length - 1}) `}
                                </span>
                            </>
                    }
                </b>
                <b>
                    {
                        draftAssessmentFilters.affiliations?.length == affiliations?.length || !draftAssessmentFilters.affiliations?.length ?
                            " בכל בתי הספר " :
                            <>
                                {" בבית ספר "}
                                <span className={`${brokenDisplay && 'blurred2'}`}>
                                    {draftAssessmentFilters.affiliations[0].name}
                                    {draftAssessmentFilters.affiliations?.length > 1 && ` (+${draftAssessmentFilters.affiliations?.length - 1}) `}
                                </span>
                            </>
                    }
                </b>
                {" "}
                <b>
                    {draftAssessmentFilters.grades?.length == grades?.length || !draftAssessmentFilters.grades?.length ?
                        " בכל השכבות " :
                        <>
                            {"ב"}
                            {draftAssessmentFilters.grades[0].name}
                            {draftAssessmentFilters.grades?.length > 1 && ` (+${draftAssessmentFilters.grades?.length - 1}) `}
                        </>
                    }
                </b>
                {!isSchoolGroup && draftAssessmentFilters.learning_group &&
                    <b>
                        {" קבוצת "}
                        {draftAssessmentFilters.learning_group.name}
                    </b>
                }
            </div>
        </HeaderStyles >
    )
}

export default AffiliationsHeader